import { ref, nextTick, watch } from 'vue';
import type { Chip } from '@/entities/tour-activities';
import { arraysEqual, toValues } from '@/shared/lib/arraysEqual';
import { useCategoryStore } from '@/shared/store';
import { EExperienceFilterType } from '@/widgets/filtersBlock';

export function useTourActivitiesSelection() {
  const categoryStore = useCategoryStore();

  // допускаем и строки, и объекты — UiChipsV3 иногда кидает объект
  const selectedValues = ref<Array<string | Chip>>([]);
  const syncingFromStore = ref(false);

  const applyFromStore = (incoming: string[] | null) => {
    const next = incoming ? [...incoming] : [];
    if (arraysEqual(incoming, toValues(selectedValues.value))) {
      return;
    }
    syncingFromStore.value = true;
    selectedValues.value = next;
    nextTick(() => (syncingFromStore.value = false));
  };

  const applyToStore = (outgoingMixed: Array<string | Chip>) => {
    if (syncingFromStore.value) {
      return;
    }
    const outgoing = toValues(outgoingMixed);
    const current = categoryStore.tmpFilters[EExperienceFilterType.TOUR_ACTIVITY_SLUGS].tour_activity_slugs;
    if (arraysEqual(current, outgoing)) {
      return;
    }
    categoryStore.setTourActivitySlugs(outgoing.length ? outgoing : []);
  };

  // авто-синк из стора
  watch(
    () => categoryStore.tmpFilters[EExperienceFilterType.TOUR_ACTIVITY_SLUGS].tour_activity_slugs,
    (v) => applyFromStore(v as string[] | null),
    { immediate: true },
  );

  // локальные изменения → стор
  watch(selectedValues, (val) => applyToStore(val), { deep: true });

  return { selectedValues };
}
